import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Quantification';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 4.5V18H10.5V19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V3.75C3 3.33579 3.33579 3 3.75 3H17.25C17.4489 3 17.6397 3.07902 17.7803 3.21967C17.921 3.36032 18 3.55109 18 3.75V8.25H16.5V4.5L4.5 4.5Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 12V15.75C10.5 16.1642 10.1642 16.5 9.75 16.5H6C5.58579 16.5 5.25 16.1642 5.25 15.75V12C5.25 11.5858 5.58579 11.25 6 11.25H9.75C10.1642 11.25 10.5 11.5858 10.5 12ZM6.75 15V12.75H9V15H6.75Z" fill="currentColor"/>
    <path d="M10.5 9C10.5 9.41421 10.1642 9.75 9.75 9.75C9.33579 9.75 9 9.41421 9 9V7.5C9 7.08579 9.33579 6.75 9.75 6.75C10.1642 6.75 10.5 7.08579 10.5 7.5V9Z" fill="currentColor"/>
    <path d="M7.875 5.25C8.28921 5.25 8.625 5.58579 8.625 6V9C8.625 9.41421 8.28921 9.75 7.875 9.75C7.46079 9.75 7.125 9.41421 7.125 9V6C7.125 5.58579 7.46079 5.25 7.875 5.25Z" fill="currentColor"/>
    <path d="M6 7.5C6.41421 7.5 6.75 7.83579 6.75 8.25V9C6.75 9.41421 6.41421 9.75 6 9.75C5.58579 9.75 5.25 9.41421 5.25 9V8.25C5.25 7.83579 5.58579 7.5 6 7.5Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 9C11.5858 9 11.25 9.33579 11.25 9.75V20.25C11.25 20.6642 11.5858 21 12 21H20.25C20.6642 21 21 20.6642 21 20.25V9.75C21 9.33579 20.6642 9 20.25 9H12ZM16.5 19.5H15.375V18H16.5V19.5ZM13.875 19.5V18H12.75V19.5H13.875ZM16.5 16.5H15.375V15H16.5V16.5ZM12.75 16.5H13.875V15H12.75V16.5ZM12.75 13.5V10.5H19.5V13.5H12.75ZM18 19.5H19.5V15H18V19.5Z" fill="currentColor"/>
  </svg>
`;

const QuantificationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M4.5 4.5V18H10.5V19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V3.75C3 3.33579 3.33579 3 3.75 3H17.25C17.4489 3 17.6397 3.07902 17.7803 3.21967C17.921 3.36032 18 3.55109 18 3.75V8.25H16.5V4.5L4.5 4.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5 12V15.75C10.5 16.1642 10.1642 16.5 9.75 16.5H6C5.58579 16.5 5.25 16.1642 5.25 15.75V12C5.25 11.5858 5.58579 11.25 6 11.25H9.75C10.1642 11.25 10.5 11.5858 10.5 12ZM6.75 15V12.75H9V15H6.75Z'
      fill='currentColor'
    />
    <path
      d='M10.5 9C10.5 9.41421 10.1642 9.75 9.75 9.75C9.33579 9.75 9 9.41421 9 9V7.5C9 7.08579 9.33579 6.75 9.75 6.75C10.1642 6.75 10.5 7.08579 10.5 7.5V9Z'
      fill='currentColor'
    />
    <path
      d='M7.875 5.25C8.28921 5.25 8.625 5.58579 8.625 6V9C8.625 9.41421 8.28921 9.75 7.875 9.75C7.46079 9.75 7.125 9.41421 7.125 9V6C7.125 5.58579 7.46079 5.25 7.875 5.25Z'
      fill='currentColor'
    />
    <path
      d='M6 7.5C6.41421 7.5 6.75 7.83579 6.75 8.25V9C6.75 9.41421 6.41421 9.75 6 9.75C5.58579 9.75 5.25 9.41421 5.25 9V8.25C5.25 7.83579 5.58579 7.5 6 7.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 9C11.5858 9 11.25 9.33579 11.25 9.75V20.25C11.25 20.6642 11.5858 21 12 21H20.25C20.6642 21 21 20.6642 21 20.25V9.75C21 9.33579 20.6642 9 20.25 9H12ZM16.5 19.5H15.375V18H16.5V19.5ZM13.875 19.5V18H12.75V19.5H13.875ZM16.5 16.5H15.375V15H16.5V16.5ZM12.75 16.5H13.875V15H12.75V16.5ZM12.75 13.5V10.5H19.5V13.5H12.75ZM18 19.5H19.5V15H18V19.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: QuantificationIcon,
  IconSvg: IconSvg
} as IconType;
